/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 14:44:15
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-30 15:54:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/index.tsx
 */
import PreviewContainer, {
  PreviewStyleSwitch,
} from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import React from 'react';
import { handleOnClear } from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit/tool';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { dispatch } from 'src/store';
import ContentPage from './ContentPage';
import styles from './css.module.less';
import Disable from './Disable';
import ModuleCart from './ModuleCart';
import Preview from './Preview';

//import ContentGroup from 'src/constrains/DraggableModules/ContentGroup';
import { beforeSubmit } from 'src/constrains/ResponsiveLayerEditor/tools';
import {
  EnumCollapseId,
  fetchContentContentPage,
  fetchInitContentContentPage,
  getH1TagUuid,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getUuid,
  getTranslationState,
  moduleContentOnChange,
  onCollapseOpen,
  onContentListResponsiveLayerEditSubmit,
  resetData,
  submitContentContentPage,
  validation,
  onChanged,
  getEntityUuid,
  translateContentPage,
} from './slice';
import Title from './Title';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { ContentModuleGroupPreloadingWrapper } from '@/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { getParameter } from '@/src/tools/helper';
import {
  useSalesChannelGeneralLinkSet,
  useSalesChannelMiniProgramLinkSet,
} from 'src/components/LinkModule/hooks';
import { useGenerateModules } from 'src/constrains/DraggableModules/useModules';
import ResponsiveEditSwitcher from 'src/constrains/ResponsiveLayerEditor';
import { useSalesChannelSubmit } from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/useSubmit';
import {
  isInPCorNative,
  isNative,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/tools';
import { NULL } from 'src/tools/constant';
import { switchUuidHooks } from './hooks/customHooks';
import RouteBlock from './RouteBlock';
import useRender from './useRender';
import ContentReverseIcon from 'src/constrains/ContentReverseIcon';
import { EnumPageType } from 'src/types/common';
import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';

const SalesChannelContentPageEditorPage = (props) => {
  const _h = useHistory();
  const _d = useDispatch();
  const handleOnChanged = () => {
    _d(onChanged());
  };
  const {
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded,
    isOnPrimaryLanguage,
    isMini,
    currentStyle,
    currentSize,
    loaded: _loaded,
  } = props;

  const _isInPC = isInPCorNative(currentStyle, currentSize);
  const _isNative = isNative(currentStyle);

  const _params: {
    saleChannelUuid: string;
    contentPageUuid: string;
    contentUuid: string;
  } = useParams();
  const { contentUuid, saleChannelUuid, contentPageUuid } = _params;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  const disable = Boolean(getParameter('disable') === 'true');
  const floatingLinkSet = useSalesChannelMiniProgramLinkSet({ contentUuid });
  const isNew = contentPageUuid === NULL;

  const h1TagUuid = useSelector(getH1TagUuid());

  const entityUuid = useSelector(getEntityUuid());
  const selectedLanguage = useSelector(currentSelectedLanguage());
  const { translationEnabled, translationLoading, uuid } = useSelector(
    getTranslationState(),
  );

  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;

  const onDiscard = () => {
    _h.push(
      `/salesChannel/editor/content/contentPage/${saleChannelUuid}/${contentUuid}`,
    );
  };

  switchUuidHooks(getUuid);
  const type = useSalesChannelType();
  React.useEffect(() => {
    return () => {
      dispatch(resetData());
      if (isNew) {
        dispatch(onCollapseOpen({ idArr: EnumCollapseId.pageSetting }));
      }
    };
  }, []);

  const renderPart = useRender(
    isOnPrimaryLanguage,
    floatingLinkSet,
    type,
    _isNative,
    translationEnabled,
  );

  const moduleList = useGenerateModules(currentStyle, moduleContentOnChange);

  const handleOnResponsiveEditSubmit = (data, cb?) => {
    _d(onContentListResponsiveLayerEditSubmit(data));
    if (cb) cb();
  };

  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateContentPage({
        uuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };
  return (
    <ContentModuleGroupPreloadingWrapper
      saleChannelUuid={saleChannelUuid}
      contentUuid={contentUuid}
      exemptUuid={contentPageUuid}>
      <React.Fragment>
        <RouteBlock hasModified={hasModified} />
        <PageWrapper
          rarePart={
            _loaded && !isNew ? (
              <ContentReverseIcon
                salesChannelUuid={saleChannelUuid}
                entityUuid={entityUuid}
                locale={selectedLanguage}
                entityType={EnumPageType.ContentPage}
                onReload={({ qParams }) => {
                  _d(
                    fetchContentContentPage({
                      //1===true 0===false
                      uuid: contentPageUuid,
                      params: qParams,
                    }),
                  );
                }}
              />
            ) : (
              <React.Fragment />
            )
          }
          customSubmit={() => {
            beforeSubmit(onContentListResponsiveLayerEditSubmit);
            setTimeout(() => {
              const a = submitData();
              const { submitFunction, isDataValid } = a || {};
              useSalesChannelSubmit({
                isValid: isDataValid,
                submit: submitFunction,
                status: salesChannel.status,
                avoidSubmitWhenHasError: false,
              });
            }, 100);
          }}
          headerConfig={{
            hasModified,
            salesChannelContentData: salesChannel || {},
            salesChannelName,
            ...(!disable && { onDiscard, submit: submitData }),
            onGoBack: onDiscard,
            hideMultiLanguage: isNew,
            hasStyleSelect: true && !isMini,
            handleOnTranslate,
            translationEnabled,
            translationLoading,
          }}
          leftChild={
            <PreviewStyleSwitch
              style={currentStyle}
              styleChild={
                <div
                  style={{
                    height: 10000,
                    backgroundColor: 'transparent',
                    // margin: '0 auto',
                  }}>
                  123
                </div>
              }
              normalChild={
                <PreviewWrapper>
                  {translationEnabled && !isOnPrimaryLanguage && (
                    <div className={styles.translationTip}>
                      <TranslationTip />
                    </div>
                  )}
                  <PreviewContainer
                    wrapperClassName={
                      translationEnabled ? styles.wrapperMarginTop : ''
                    }>
                    <Preview />
                  </PreviewContainer>
                </PreviewWrapper>
              }
            />
          }
          rightChild={
            <ResponsiveEditSwitcher
              config={{
                isPrimary: isOnPrimaryLanguage,
                siteStyle: currentStyle,
                breakpoint: currentSize,
              }}
              onChanged={handleOnChanged}
              onSubmit={handleOnResponsiveEditSubmit}>
              <div className={styles.rightContainer}>
                <div className={styles.moduleCart}>
                  {!disable && _isInPC && !translationEnabled && (
                    <ModuleCart
                      moduleList={moduleList}
                      disabled={translationEnabled}
                    />
                  )}
                </div>
                {loaded ? (
                  <RightConfigWrapper
                    title={<Title />}
                    elements={
                      disable
                        ? [
                            {
                              body: <Disable />,
                              key: 'topConfig',
                            },
                          ]
                        : [
                            {
                              body: renderPart,
                              key: 'topConfig',
                            },
                            {
                              key: 'moduleContent',
                              //loaded ?
                              body: (
                                <ContentPage
                                  linkSet={linkSet}
                                  disabled={!_isInPC}
                                  allDisabled={translationEnabled}
                                  extraProps={{
                                    h1TagUuid: h1TagUuid,
                                    siteStyle: currentStyle,
                                    breakpoint: currentSize,
                                  }}
                                />
                              ),
                              // : null,
                            },
                          ]
                    }
                  />
                ) : null}
              </div>
            </ResponsiveEditSwitcher>
          }
        />
      </React.Fragment>
    </ContentModuleGroupPreloadingWrapper>
  );
};

export default BasicPageHOC(SalesChannelContentPageEditorPage, {
  beforeRequest: handleOnClear,
  getState,
  siteStyleInParams: true,
  previewSizeInParams: true,
  convertDataFromReduxToServer,
  submit: submitContentContentPage,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid, contentPageUuid } = params;
    if (contentPageUuid !== NULL) {
      dispatch(
        fetchContentContentPage({
          uuid: contentPageUuid,
          params: qParams,
        }),
      );
    } else {
      dispatch(
        fetchInitContentContentPage({
          uuid: contentUuid,
          params: qParams,
        }),
      );
    }
  },
});
